export enum PaymentGateway {
    Demo = 0,
    POS = 1,    
    Stripe = 2,
    Shift4 = 3,
    CardConnect = 4,
    Elavon = 5,
    GlobalPay = 6,
    FreedomPay = 7,
    Heartland = 8,
    ParPay = 9
}